import { BooleanInput, Create, CreateContextProvider, Edit, EditContextProvider, Form, required, SaveButton, SelectInput, TextInput, Toolbar, TopToolbar, useCreateController, useEditController, useNotify, useRedirect, useRefresh, useTranslate } from 'react-admin';
import { Box, Card, Divider, Stack, Typography, Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../../resource';
import TokenMetadataForm from './TokenMetadataForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const EditMetadata = ({ id, onClose }: { id: string | number; onClose: () => void }) => {
    const notify = useNotify();
    const t = useTranslate();
    const refresh = useRefresh();

    const controller = useEditController({
        id,
        resource: Resources.tokenMetadata,
        mutationMode: 'pessimistic',
        mutationOptions: {
            onSuccess: () => {
                notify(t('module.tokenMetadata.updateSuccess'), { type: 'success' });
                refresh()
                onClose()
            },
            onError: (error: any) => {
                const errorCode = error?.body?.code || error?.code;
                switch (errorCode) {
                    case 'TOKEN_METADATA_ALREADY_EXISTS':
                        notify(t('module.tokenMetadata.validate.conflict'), { type: 'error' });
                        break;
                    default:
                        notify(t('module.tokenMetadata.unknownErrorUpdate'), { type: 'error' });
                        break;
                }
            },
        },
    });
    
    if (controller.isLoading || !controller.record) return null;

    return (
        <EditContextProvider value={controller}>
            <Form disableInvalidFormNotification>
                <DialogTitle>{t('module.tokenMetadata.editToken')}</DialogTitle>
                <DialogContent>
                    <TokenMetadataForm isCreate={false} />
                </DialogContent>
                <DialogActions>
                    <MUIButton
                        variant="outlined"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t('actions.cancel')}
                    </MUIButton>
                    <PermissionButton resource="token-metadatas" action="update">
                        <SaveButton />
                    </PermissionButton>
                </DialogActions>
            </Form>
        </EditContextProvider>
    );
};

export default EditMetadata;
